import React from 'react';
import { DoodleSquiggle, DoodleStar } from '../brand/Doodles';
type EmptyStateProps = {
  title: string;
  copy: string;
  /** Small uppercase label above the title. */
  label?: string;
  children?: React.ReactNode;
  tone?: 'tan' | 'blue' | 'white';
};
const tones = {
  tan: 'bg-brand-tan',
  blue: 'bg-brand-blue',
  white: 'bg-white'
} as const;

/**
 * Reusable empty state for sections whose content has not been confirmed yet.
 * Keeps the page useful instead of inventing filler content.
 */
export function EmptyState({
  title,
  copy,
  label,
  children,
  tone = 'tan'
}: EmptyStateProps) {
  return <div className={`relative overflow-hidden rounded-[24px] border-2 border-dashed border-brand-navy p-7 sm:p-9 ${tones[tone]}`} data-id="element-341" data-mp="14or4uvc224nm">
      <DoodleSquiggle className="pointer-events-none absolute -right-4 top-4 h-8 w-32" color="var(--bcm-dark-blue)" data-id="element-342" data-mp="19h0su5tm0un9" />
      {/* Hidden on mobile, where stacked full-width buttons fill that corner. */}
      <DoodleStar className="pointer-events-none absolute bottom-5 right-8 hidden h-8 w-8 sm:block" color={tone === 'blue' ? 'var(--bcm-tan)' : 'var(--bcm-yellow)'} data-id="element-343" data-mp="gx2al9fob641" />
      {label ? <p className="font-meta text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-navy" data-id="element-344" data-mp="xz9q8xkz2mu7">
          {label}
        </p> : null}
      <h3 className="relative mt-2 max-w-xl font-serif text-2xl font-semibold leading-snug text-brand-navy sm:text-[1.75rem]" data-id="element-345" data-mp="szdoz63nt9ic">
        {title}
      </h3>
      <p className="mt-3 max-w-xl font-sans text-[16px] leading-relaxed text-ink" data-id="element-346" data-mp="jzqmegz71xnp">{copy}</p>
      {children ? <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:flex-wrap" data-id="element-347" data-mp="f05kbxoq996r">{children}</div> : null}
    </div>;
}